import { createTheme } from '@material-ui/core';
import { fieldMaxWidth } from 'components/Forms/styles';
import { newSemanticColours } from 'styles/colours';
import defaultTheme, { feedbackButtonZIndex } from 'styles/defaultTheme';

const reserveCapacityTheme = createTheme({
  ...defaultTheme,
  overrides: {
    MuiTableCell: {
      head: {
        padding: defaultTheme.spacing(2, 1),
        fontWeight: 400
      }
    },
    MuiButton: {
      root: {
        padding: defaultTheme.spacing(1, 2),
        textTransform: 'capitalize'
      },
      text: {
        padding: defaultTheme.spacing(1, 2)
      },
      textSecondary: {
        color: defaultTheme.palette.aegis.semantic.message.black
      },
      containedSizeLarge: {
        padding: defaultTheme.spacing(1)
      },
      containedSizeSmall: {
        padding: defaultTheme.spacing(1, 2)
      },
      startIcon: {
        marginLeft: 0
      }
    },
    MuiIconButton: {
      label: {
        '& svg': {
          fill: newSemanticColours.message.dark
        }
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: defaultTheme.spacing(3)
      }
    },
    MuiPaginationItem: {
      root: {
        '&.Mui-selected': {
          backgroundColor: `${defaultTheme.palette.aegis.semantic.primary.base} !important`
        }
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: defaultTheme.spacing(3),
        marginRight: defaultTheme.spacing(1),
        fontSize: defaultTheme.spacing(3),
        color: defaultTheme.palette.aegis.semantic.background.canvas
      }
    },
    MuiAlert: {
      standardError: {
        color: defaultTheme.palette.aegis.semantic.message.black
      }
    },
    MuiInputLabel: {
      root: {
        color: defaultTheme.palette.aegis.semantic.message.black
      }
    },
    MuiInputBase: {
      root: {
        padding: defaultTheme.spacing(1.5, 0.25, 1.5, 2),
        alignItems: 'center'
      },
      input: {
        height: defaultTheme.spacing(2.5),
        padding: 0,
        color: defaultTheme.palette.aegis.semantic.message.black
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: 0
      },
      inputMarginDense: {
        paddingTop: 0,
        paddingBottom: 0
      },
      adornedEnd: {
        paddingRight: defaultTheme.spacing(1.5)
      },
      notchedOutline: {
        borderColor: defaultTheme.palette.aegis.colour.grey.dark
      }
    },
    MuiAutocomplete: {
      root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      },
      inputRoot: {
        '&[class*="MuiOutlinedInput-root"]': {
          padding: defaultTheme.spacing(0.3125, 1.25),
          '.multiSelect &': {
            paddingTop: defaultTheme.spacing(0.5),
            paddingBottom: defaultTheme.spacing(0.5)
          }
        }
      },
      endAdornment: {
        top: 'auto',
        display: 'flex',
        paddingRight: defaultTheme.spacing(1.5)
      },
      popper: {
        zIndex: feedbackButtonZIndex + 1,
        minWidth: defaultTheme.spacing(fieldMaxWidth + 0.5)
      },
      paper: {
        padding: defaultTheme.spacing(1, 1)
      },
      option: {
        '&': {
          padding: defaultTheme.spacing(1, 1)
        }
      }
    },
    MuiFormControlLabel: {
      root: {
        marginRight: 0
      },
      label: {
        color: defaultTheme.palette.aegis.semantic.message.black
      }
    },
    MuiFormLabel: {
      root: {
        color: defaultTheme.palette.aegis.semantic.message.black,
        marginBottom: defaultTheme.spacing(1),
        '.weekdays &': {
          alignSelf: 'flex-start'
        }
      }
    },
    MuiCheckbox: {
      root: {
        '&.Mui-focusVisible svg': {
          fill: defaultTheme.palette.primary.dark
        }
      }
    },
    MuiFormHelperText: {
      root: {
        width: '100%',
        '&[class*="MuiFormHelperText-contained"]': {
          margin: defaultTheme.spacing(0.5, 0, 0, 0)
        }
      }
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: defaultTheme.containers.small
      }
    },
    MuiDialogTitle: {
      root: {
        padding: defaultTheme.spacing(4, 3, 2)
      }
    },
    MuiDialogActions: {
      root: {
        padding: defaultTheme.spacing(2, 3, 3)
      }
    },
    MuiChip: {
      root: {
        height: defaultTheme.spacing(3),
        backgroundColor: defaultTheme.palette.aegis.colour.grey.lightest
      },
      deleteIcon: {
        height: defaultTheme.spacing(2),
        fill: newSemanticColours.message.dark
      }
    },
    PrivateSwitchBase: {
      root: {
        padding: defaultTheme.spacing(1)
      }
    }
  },
  palette: {
    ...defaultTheme.palette,
    aegis: {
      ...defaultTheme.palette.aegis,
      semantic: newSemanticColours
    }
  }
});

export { reserveCapacityTheme as default };
